import script from "./slotokno.vue?vue&type=script&setup=true&lang=js"
export * from "./slotokno.vue?vue&type=script&setup=true&lang=js"

import "./slotokno.vue?vue&type=style&index=0&id=512790d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512790d4"]])

export default __exports__